<template>
			<b-overlay :show="item.type == null">
					<div class="card mb-2" :class="sortalysContract ? 'd-none': 'd-flex' ">
						<div class="d-flex card-body card-silver p-2">
							<table>
								<tbody>
									<tr :class="pvContract ? 'd-none': ''">
										<td>{{ $t('sandoz.marketing_activity_total_maximum') }}</td>
										<td class="text-right">{{ item.marketing_activities_maximum | formatNumber }}</td>
									</tr>
									<tr>
										<td>{{ apoOtcContract  ? $t('sandoz.marketing_activity_otc_sortalys_selected') : $t('sandoz.marketing_activity_total_selected') }}</td>
										<td class="text-right">{{ item.marketing_activities | formatNumber}}</td>
									</tr>
									<tr v-if="apoOtcContract">
										<td>{{ $t('sandoz.marketing_activity_otc') }}</td>
										<td class="text-right">{{ (item.marketing_activities - sortalysPrice) | formatNumber}}</td>
									</tr>
									<tr :class="pvContract ? 'd-none': ''">
										<td>{{ $t('sandoz.marketing_activity_total_available') }}</td>
										<td class="text-right" :class="{'text-danger': Math.sign(marketingActivityTotalAvailable()) === -1}">{{ marketingActivityTotalAvailable() | formatNumber }} </td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				<template v-for="(address, index) in item.addresses">
						<template v-if="address.address_type === 'delivery'">
						<div class="d-flex">
								<div class="pt-2">
								<b>
										{{ address.company_name ?  address.company_name + ', ' : '' }}
										{{ address.street ? address.street + ', ' : '' }}
										{{ address.zip }} {{ address.city }}
								</b>
								<b-badge v-if="address.cap_exceeded" pill href="#"  class="ml-2" variant="danger">{{$t('sandoz.cap_exceeded')}}</b-badge>
								</div>
								<div class="ml-auto">
								<div v-if="!address.fte && !address.customer_size && !sortalysContract" class="badge badge-danger">{{$t('sandoz.unclassified_address')}}</div>
								</div>
						</div>
						<div class="table-responsive mt-3 ml-2 ice-item-table-div" v-if="address.fte || address.customer_size || sortalysContract">
								<table class="table table-sm ice-item-table">
								<thead>
								<tr>
										<th scope="col" class=""></th>
										<th scope="col" class="mw-400">{{ $t('sandoz.item') }}</th>
										<th scope="col">{{ $t('sandoz.item_price') }}</th>
										<th scope="col">{{ $t('sandoz.price') }}</th>
										<th scope="col">{{ $t('sandoz.quantity') }}</th>
										<th scope="col" class="text-nowrap" :class="{'d-none': sortalysContract}">{{ $t('sandoz.exists') }}
										<b-popover :target="`popover-exists-info`" triggers="hover focus">
												<div v-html="$t('sandoz.exist_info_text_checked')"></div>
												<div v-html="$t('sandoz.exist_info_text_unchecked')"></div>
										</b-popover>
										<fa icon="circle-info" :id="`popover-exists-info`"></fa>
										</th>
										<th scope="col" :class="{'d-none': sortalysContract}">{{ $t('sandoz.qty_1') }}</th>
										<th scope="col" :class="{'d-none': sortalysContract}">{{ $t('sandoz.qty_2') }}</th>
										<th scope="col" :class="{'d-none': sortalysContract}">{{ $t('sandoz.qty_3') }}</th>
										<th scope="col" :class="{'d-none': sortalysContract}">{{ $t('sandoz.qty_4') }}</th>
										<th scope="col" :class="{'d-none': sortalysContract}">{{ $t('sandoz.from') }}</th>
										<th scope="col" :class="{'d-none': sortalysContract}">{{ $t('sandoz.to') }}</th>
								</tr>
								</thead>
								<tbody v-if="address.items && Object.keys(address.items).length">
								<template v-for="(line, lineIndex) in address.items">
										<tr class="master-item" v-if="line.type === 'marketing_activity'">
										<td>
												<div class="item-accordion cursor-pointer"
														v-if="checkLineChildren(line)">
												<fa icon="plus" @click="toggleAccordion(index, lineIndex)"
														v-if="getAccordion(index, lineIndex) === -1"/>
												<fa icon="minus" @click="toggleAccordion(index, lineIndex)"
														v-if="getAccordion(index, lineIndex) !== -1"/>
												</div>
										</td>
										<td>
												<div v-if="!line.allow_product_name_to_change"> {{ line.product ? line.product.name : line.product_name }}
												<router-link v-if="user && user.is_super_user && line.product && line.product.product_master_id" target="_blank"
																				:to="{ path: '/sandoz/product_masters/' + line.product.product_master_id }">
														<fa icon="pencil-alt"/>
												</router-link>
												<a :href="linkValidate(line.product.info_link)" target="_blank" v-if="line.product && line.product.info_link">
														<fa icon="file"/>
												</a>
												<fa v-if="line.product && line.product.product_master && line.product.product_master.picture"
														icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(line)"/>
												</div>
												<div v-else>
												<o-input-control type="text" v-model="line.product_name" class="full-width mw-95"> </o-input-control>
												<router-link v-if="user && user.is_super_user && line.product && line.product.product_master_id" target="_blank"
																				:to="{ path: '/sandoz/product_masters/' + line.product.product_master_id }">
														<fa icon="pencil-alt"/>
												</router-link>
												<a :href="linkValidate(line.product.info_link)" target="_blank" v-if="line.product && line.product.info_link">
														<fa icon="file"/>
												</a>
												<fa v-if="line.product && line.product.product_master && line.product.product_master.picture"
														icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(line)"/>
												</div>
										</td>
										<td class="item-price">{{ line.item_price | formatRoundNumber }}</td>
										<td>
												<template v-if="line.price_changes && line.price_changes.price_changes === 'no_changes_allowed'">
												<div class="w-100">
														<div class="form-control text-right" readonly="readonly">{{line.price | formatInteger}}</div>
												</div>
												</template>
												<template v-else>
												<o-input-control :ignore-range="true" :step="1" type="number" v-model="line.price"
																						@blur="validatePrice(line, index), setPrice(line, index)" class="form-price" format="integer"></o-input-control>
												</template>
										</td>
										<td :class="{'exist_error': (line && reqBiosApoItems.includes(address.id + '-' + line.product.id) && !isReadonly(line, 'yearly'))}">
												<template v-if="isReadonly(line, 'yearly')">
												<div class="w-100 form-qty" v-if="line.delivery.yearly">
														<div class="form-control" readonly="readonly">{{line.delivery.yearly.quantity}}</div>
												</div>
												</template>
												<template v-else>
												<o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.yearly.quantity"
																						@previous-value="setPreviousQuantity($event, line, 'yearly')"
																						@blur="setPrice(line, index, 'yearly'), setQuantityToChild(line, 'yearly', index)"
																						class="form-qty">
												</o-input-control>
												</template>
										</td>
										<td :class="{'d-none': sortalysContract, 'exist_error': (line && determErrorID.includes(address.id+'-'+line.product.id))}">
												<template
												v-if="line && (line.delivery.yearly.quantity > 0 || line.delivery.q1.quantity > 0 || line.delivery.q2.quantity > 0 || line.delivery.q3.quantity > 0 || line.delivery.q4.quantity > 0)">
												<template v-if="line.attribute_required || line.exist_value !== null">
														<b-form-checkbox v-model="line.contract_line_exist_attribute"
																						:disabled="readonly || line.exist_value !== null"
																						:indeterminate="line.exist_value === null && !!line.indeterminate">
														</b-form-checkbox>
												</template>
												</template>
										</td>
										<td :class="{'d-none': sortalysContract, 'exist_error': (line && reqBiosApoItems.includes(address.id + '-' + line.product.id) && !isReadonly(line, 'q1'))}">
												<template v-if="isReadonly(line, 'q1')">
												<div class="w-100 form-qty" v-if="line.delivery.q1">
														<div class="form-control" readonly="readonly"
																:class="{'sync_quarter': line.sync_quarter_q1, 'set-error': line.delivery.q1 && line.delivery.q1.error}">{{line.delivery.q1.quantity}}
														</div>
												</div>
												</template>
												<template v-else>
												<o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.q1.quantity"
																						@previous-value="setPreviousQuantity($event, line, 'q1')"
																						@blur="setPrice(line, index, 'q1'), setQuantityToChild(line, 'q1', index)"
																						class="form-qty"
																						:class="{'sync_quarter': line.sync_quarter_q1, 'set-error': line.delivery.q1 && line.delivery.q1.error}">
												</o-input-control>
												</template>
										</td>
										<td :class="{'d-none': sortalysContract, 'exist_error': (line && reqBiosApoItems.includes(address.id + '-' + line.product.id) && !isReadonly(line, 'q2'))}">
												<template v-if="isReadonly(line, 'q2')">
												<div class="w-100 form-qty" v-if="line.delivery.q2">
														<div class="form-control" readonly="readonly"
																:class="{'sync_quarter': line.sync_quarter_q2, 'set-error': line.delivery.q2 && line.delivery.q2.error}">{{line.delivery.q2.quantity}}</div>
												</div>
												</template>
												<template v-else>
												<o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.q2.quantity"
																						@previous-value="setPreviousQuantity($event, line, 'q2')"
																						@blur="setPrice(line, index, 'q2'), setQuantityToChild(line, 'q2', index)"
																						class="form-qty"
																						:class="{'sync_quarter': line.sync_quarter_q2, 'set-error': line.delivery.q2 && line.delivery.q2.error}">
												</o-input-control>
												</template>
										</td>
										<td :class="{'d-none': sortalysContract, 'exist_error': (line && reqBiosApoItems.includes(address.id + '-' + line.product.id) && !isReadonly(line, 'q3'))}">
												<template v-if="isReadonly(line, 'q3')">
												<div class="w-100 form-qty" v-if="line.delivery.q3">
														<div class="form-control" readonly="readonly"
																:class="{'sync_quarter': line.sync_quarter_q3, 'set-error': line.delivery.q3 && line.delivery.q3.error}">{{line.delivery.q3.quantity}}</div>
												</div>
												</template>
												<template v-else>
												<o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.q3.quantity"
																						@previous-value="setPreviousQuantity($event, line, 'q3')"
																						@blur="setPrice(line, index, 'q3'), setQuantityToChild(line, 'q3', index)"
																						class="form-qty"
																						:class="{'sync_quarter': line.sync_quarter_q3, 'set-error': line.delivery.q3 && line.delivery.q3.error}">
												</o-input-control>
												</template>
										</td>
										<td :class="{'d-none': sortalysContract, 'exist_error': (line && reqBiosApoItems.includes(address.id + '-' + line.product.id) && !isReadonly(line, 'q4'))}">
												<template v-if="isReadonly(line, 'q4')">
												<div class="w-100 form-qty" v-if="line.delivery.q4">
														<div class="form-control" readonly="readonly"
																:class="{'sync_quarter': line.sync_quarter_q4, 'set-error': line.delivery.q4 && line.delivery.q4.error}">{{line.delivery.q4.quantity}}</div>
												</div>
												</template>
												<template v-else>
												<o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.q4.quantity"
																						@previous-value="setPreviousQuantity($event, line, 'q4')"
																						@blur="setPrice(line, index, 'q4'), setQuantityToChild(line, 'q4', index)"
																						class="form-qty"
																						:class="{'sync_quarter': line.sync_quarter_q4, 'set-error': line.delivery.q4 && line.delivery.q4.error}">
												</o-input-control>
												</template>
										</td>
										<td :class="{'d-none': sortalysContract, 'exist_error': line && fromDateErrorID.includes(address.id+'-'+line.product.id)}">
												<o-value-select-control v-model="line.valid_from_month" :items="months"
																								:readonly="!line.allow_manual_date_entry"
																								@change.native="setDateToChildren(line, index), setDateChanged(line, 'from')">
												</o-value-select-control>
										</td>
										<td :class="{'d-none': sortalysContract}">
												<o-value-select-control v-model="line.valid_to_month" :items="months"
																								:readonly="!line.allow_manual_date_entry"
																								@change.native="setDateToChildren(line, index, 'to'), setDateChanged(line, 'to')">
												</o-value-select-control>
										</td>
										</tr>
										<template v-if="line.type === 'marketing_activity' && line.children && Object.keys(line.children).length">
										<template v-for="(subLine, subLineIndex) in line.children">
												<tr :class="{'d-none': (getAccordion(index, lineIndex) === -1)}">
												<td>
														<div class="item-accordion cursor-pointer sub-accordion-icon"
																v-if="checkLineChildren(subLine)">
														<fa icon="plus" @click="toggleAccordion(lineIndex, subLineIndex)"
																v-if="getAccordion(lineIndex, subLineIndex) === -1"/>
														<fa icon="minus" @click="toggleAccordion(lineIndex, subLineIndex)"
																v-if="getAccordion(lineIndex, subLineIndex) !== -1"/>
														</div>
												</td>
												<td class="indention" v-if="!subLine.allow_product_name_to_change">{{ subLine.product ? subLine.product.name : subLine.product_name }}
														<router-link v-if="user && user.is_super_user && subLine.product && subLine.product.product_master_id" target="_blank"
																				:to="{ path: '/sandoz/product_masters/' + subLine.product.product_master_id }">
														<fa icon="pencil-alt"/>
														</router-link>
														<a :href="linkValidate(subLine.product.info_link)" target="_blank" v-if="subLine.product && subLine.product.info_link">
														<fa icon="file"/>
														</a>
														<fa v-if="subLine.product && subLine.product.product_master && subLine.product.product_master.picture"
																icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(subLine)"/>
												</td>
												<td class="indention" v-else>
														<o-input-control type="text" v-model="subLine.product_name" class="full-width mw-95"> </o-input-control>
														<router-link v-if="user && user.is_super_user && subLine.product && subLine.product.product_master_id" target="_blank"
																				:to="{ path: '/sandoz/product_masters/' + subLine.product.product_master_id }">
														<fa icon="pencil-alt"/>
														</router-link>
														<a :href="linkValidate(subLine.product.info_link)" target="_blank" v-if="subLine.product && subLine.product.info_link">
														<fa icon="file"/>
														</a>
														<fa v-if="subLine.product && subLine.product.product_master && subLine.product.product_master.picture"
																icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(subLine)"/>
												</td>
												<td class="item-price">{{ subLine.item_price | formatRoundNumber }}</td>
												<td>
														<template v-if="subLine.price_changes && subLine.price_changes.price_changes === 'no_changes_allowed'">
														<div class="w-100">
																<div class="form-control text-right" readonly="readonly">{{subLine.price | formatInteger}}</div>
														</div>
														</template>
														<template v-else>
														<o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.price"
																								@blur="validatePrice(subLine, index)" class="form-price"  format="integer"></o-input-control>
														</template>
												</td>
												<td :class="{'exist_error': (subLine && reqBiosApoItems.includes(address.id + '-' + subLine.product.id) && !isReadonly(subLine, 'yearly'))}">
														<template v-if="isReadonly(subLine, 'yearly')">
														<div class="w-100 form-qty" v-if="subLine.delivery.yearly">
																<div class="form-control" readonly="readonly">{{subLine.delivery.yearly.quantity}}</div>
														</div>
														</template>
														<template v-else>
														<o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.yearly.quantity"
																								@previous-value="setPreviousQuantity($event, subLine, 'yearly')"
																								@blur="setQuantityToParent(line, subLine, 'yearly', index),
																								setQuantityToChild(subLine, 'yearly', subLineIndex),
																								setBoxQuantity(line, 'yearly', subLine.box_or_gadget, index)
																								setQuantityToChildSpecial(line, 'yearly', index)"
																								class="form-qty">
														</o-input-control>
														</template>
												</td>
												<td :class="{'d-none': sortalysContract, 'exist_error': (determErrorID.includes(address.id+'-'+subLine.product.id))}">
														<template
														v-if="subLine.delivery.yearly.quantity > 0 || subLine.delivery.q1.quantity > 0 || subLine.delivery.q2.quantity > 0 || subLine.delivery.q3.quantity > 0 || subLine.delivery.q4.quantity > 0">
														<template v-if="subLine.attribute_required || subLine.exist_value !== null">
																<b-form-checkbox v-model="subLine.contract_line_exist_attribute"
																								:disabled="readonly || subLine.exist_value !== null"
																								:indeterminate="subLine.exist_value === null && !!subLine.indeterminate">
																</b-form-checkbox>
														</template>
														</template>
												</td>
												<td :class="{'d-none': sortalysContract, 'exist_error': (subLine && reqBiosApoItems.includes(address.id + '-' + subLine.product.id) && !isReadonly(subLine, 'q1', true))}">
														<template v-if="isReadonly(subLine, 'q1', true)">
														<div class="w-100 form-qty" v-if="subLine.delivery.q1">
																<div class="form-control" readonly="readonly"
																		:class="{'sync_quarter': subLine.sync_quarter_q1, 'set-error': subLine.delivery.q1 && subLine.delivery.q1.error}">{{subLine.delivery.q1.quantity}}</div>
														</div>
														</template>
														<template v-else>
														<o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.q1.quantity"
																								@previous-value="setPreviousQuantity($event, subLine, 'q1')"
																								@blur="setQuantityToParent(line, subLine, 'q1', index),
																								setQuantityToChild(subLine, 'q1', subLineIndex),
																								setBoxQuantity(line, 'q1', subLine.box_or_gadget, index)
																								setQuantityToChildSpecial(line, 'q1', index)"
																								class="form-qty"
																								:class="{'sync_quarter': subLine.sync_quarter_q1, 'set-error': subLine.delivery.q1 && subLine.delivery.q1.error}">
														</o-input-control>
														</template>
												</td>
												<td :class="{'d-none': sortalysContract, 'exist_error': (subLine && reqBiosApoItems.includes(address.id + '-' + subLine.product.id) && !isReadonly(subLine, 'q2', true))}">
														<template v-if="isReadonly(subLine, 'q2', true)">
														<div class="w-100 form-qty" v-if="subLine.delivery.q2">
																<div class="form-control" readonly="readonly"
																		:class="{'sync_quarter': subLine.sync_quarter_q2, 'set-error': subLine.delivery.q2 && subLine.delivery.q2.error}">{{subLine.delivery.q2.quantity}}</div>
														</div>
														</template>
														<template v-else>
														<o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.q2.quantity"
																								@previous-value="setPreviousQuantity($event, subLine, 'q2')"
																								@blur="setQuantityToParent(line, subLine, 'q2', index),
																								setQuantityToChild(subLine, 'q2', subLineIndex),
																								setBoxQuantity(line, 'q2', subLine.box_or_gadget, index)
																								setQuantityToChildSpecial(line, 'q2', index)"
																								class="form-qty"
																								:class="{'sync_quarter': subLine.sync_quarter_q2, 'set-error': subLine.delivery.q2 && subLine.delivery.q2.error}">
														</o-input-control>
														</template>
												</td>
												<td :class="{'d-none': sortalysContract, 'exist_error': (subLine && reqBiosApoItems.includes(address.id + '-' + subLine.product.id) && !isReadonly(subLine, 'q3', true))}">
														<template v-if="isReadonly(subLine, 'q3', true)">
														<div class="w-100 form-qty" v-if="subLine.delivery.q3">
																<div class="form-control" readonly="readonly" :class="subLine.sync_quarter_q3 ? 'sync_quarter' : ''">{{subLine.delivery.q3.quantity}}</div>
														</div>
														</template>
														<template v-else>
														<o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.q3.quantity"
																								@previous-value="setPreviousQuantity($event, subLine, 'q3')"
																								@blur="setQuantityToParent(line, subLine, 'q3', index)
																								setQuantityToChild(subLine, 'q3', subLineIndex)
																								setBoxQuantity(line, 'q3', subLine.box_or_gadget, index)
																								setQuantityToChildSpecial(line, 'q3', index)"
																								class="form-qty"
																								:class="{'sync_quarter': subLine.sync_quarter_q3, 'set-error': subLine.delivery.q3 && subLine.delivery.q3.error}">
														</o-input-control>
														</template>
												</td>
												<td :class="{'d-none': sortalysContract, 'exist_error': (subLine && reqBiosApoItems.includes(address.id + '-' + subLine.product.id) && !isReadonly(subLine, 'q4', true))}">
														<template v-if="isReadonly(subLine, 'q4', true)">
														<div class="w-100 form-qty" v-if="subLine.delivery.q4">
																<div class="form-control form-qty" readonly="readonly" :class="subLine.sync_quarter_q4 ? 'sync_quarter' : ''">{{subLine.delivery.q4.quantity}}</div>
														</div>
														</template>
														<template v-else>
														<o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.q4.quantity"
																								@previous-value="setPreviousQuantity($event, subLine, 'q4')"
																								@blur="setQuantityToParent(line, subLine, 'q4', index),
																								setQuantityToChild(subLine, 'q4', subLineIndex),
																								setBoxQuantity(line, 'q4', subLine.box_or_gadget, index)
																						setQuantityToChildSpecial(line, 'q4', index)"
																								class="form-qty"
																								:class="{'sync_quarter': subLine.sync_quarter_q4, 'set-error': subLine.delivery.q4 && subLine.delivery.q4.error}">
														</o-input-control>
														</template>
												</td>
												<td :class="{'exist_error': (subLine && fromDateErrorID.includes(address.id+'-'+subLine.product.id)), 'd-none': (sortalysContract || (!!!subLine.delivery.yearly.quantity && !!!subLine.delivery.q1.quantity && !!!subLine.delivery.q2.quantity && !!!subLine.delivery.q3.quantity && !!!subLine.delivery.q4.quantity))}">
														<o-value-select-control v-model="subLine.valid_from_month" :items="months"
																										:readonly="!subLine.allow_manual_date_entry"
																										@change.native="setDateToChildren(subLine, index, 'from'), setDateChanged(subLine, 'from')">
														</o-value-select-control>
												</td>
												<td :class="{'d-none': sortalysContract || (!!!subLine.delivery.yearly.quantity && !!!subLine.delivery.q1.quantity && !!!subLine.delivery.q2.quantity && !!!subLine.delivery.q3.quantity && !!!subLine.delivery.q4.quantity)}">
														<o-value-select-control v-model="subLine.valid_to_month" :items="months"
																										:readonly="!subLine.allow_manual_date_entry"
																										@change.native="setDateToChildren(subLine, index, 'to'), setDateChanged(subLine, 'to')">
														</o-value-select-control>
												</td>
												<td class="text-right text-nowrap">
												</td>
												</tr>
												<template v-if="line.type === 'marketing_activity' && subLine.children && Object.keys(subLine.children).length">
												<template v-for="(childLine, childLineIndex) in subLine.children">
														<tr :class="{'d-none': (getAccordion(lineIndex, subLineIndex) === -1 ||  getAccordion(index, lineIndex) === -1)}">
														<td></td>
														<td class="indention-1" v-if="!childLine.allow_product_name_to_change">{{ childLine.product ? childLine.product.name : childLine.product_name }}
																<router-link v-if="user && user.is_super_user && childLine.product && childLine.product.product_master_id" target="_blank"
																						:to="{ path: '/sandoz/product_masters/' + childLine.product.product_master_id }">
																<fa icon="pencil-alt"/>
																</router-link>
																<a :href="linkValidate(childLine.product.info_link)" target="_blank" v-if="childLine.product && childLine.product.info_link">
																<fa icon="file"/>
																</a>
																<fa v-if="childLine.product && childLine.product.product_master && childLine.product.product_master.picture"
																		icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(childLine)"/>
														</td>
														<td class="indention-1" v-else>
																<o-input-control type="text" v-model="childLine.product_name" class="full-width mw-95"> </o-input-control>
																<router-link v-if="user && user.is_super_user && childLine.product && childLine.product.product_master_id" target="_blank"
																						:to="{ path: '/sandoz/product_masters/' + childLine.product.product_master_id }">
																<fa icon="pencil-alt"/>
																</router-link>
																<a :href="linkValidate(childLine.product.info_link)" target="_blank" v-if="childLine.product && childLine.product.info_link">
																<fa icon="file"/>
																</a>
																<fa v-if="childLine.product && childLine.product.product_master && childLine.product.product_master.picture"
																		icon="camera" class="text-primary cursor-pointer" @click="openPictureOverlay(childLine)"/>
														</td>
														<td class="item-price">{{ childLine.item_price | formatRoundNumber }}</td>
														<td>
																<template v-if="childLine.price_changes && childLine.price_changes.price_changes === 'no_changes_allowed'">
																<div class="w-100">
																		<div class="form-control text-right" readonly="readonly">{{childLine.price | formatInteger}}</div>
																</div>
																</template>
																<template v-else>
																<o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.price"
																										@blur="validatePrice(childLine, index)" class="form-price"  format="integer"></o-input-control>
																</template>
														</td>
														<td :class="{'exist_error': (childLine && reqBiosApoItems.includes(address.id + '-' + childLine.product.id) && !isReadonly(childLine, 'yearly'))}">
																<template v-if="isReadonly(childLine, 'yearly')">
																<div class="w-100 form-qty" v-if="childLine.delivery.yearly">
																		<div class="form-control" readonly="readonly">{{childLine.delivery.yearly.quantity}}</div>
																</div>
																</template>
																<template v-else-if="childLine.delivery.yearly">
																<o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.yearly.quantity"
																										@previous-value="setPreviousQuantity($event, childLine, 'yearly')"
																										@blur="setQuantityToParent(subLine, childLine, 'yearly', index),
																										setBoxQuantity(line, 'yearly', childLine.box_or_gadget, index)"
																										class="form-qty">
																</o-input-control>
																</template>
														</td>
														<td :class="{'d-none': sortalysContract, 'exist_error': determErrorID.includes(address.id+'-'+childLine.product.id)}">
																<template
																v-if="childLine.delivery.yearly.quantity > 0 || childLine.delivery.q1.quantity > 0 || childLine.delivery.q2.quantity > 0 || childLine.delivery.q3.quantity > 0 || childLine.delivery.q4.quantity > 0">
																<template
																		v-if="childLine.attribute_required || childLine.exist_value !== null">
																		<b-form-checkbox v-model="childLine.contract_line_exist_attribute"
																										:disabled="readonly || childLine.exist_value !== null"
																										:indeterminate="childLine.exist_value === null && !!childLine.indeterminate">
																		</b-form-checkbox>
																</template>
																</template>
														</td>
														<td :class="{'d-none': sortalysContract, 'exist_error': (childLine && reqBiosApoItems.includes(address.id + '-' + childLine.product.id) && !isReadonly(childLine, 'q1', true))}">
																<template v-if="isReadonly(childLine, 'q1', true)">
																<div class="w-100 form-qty" v-if="childLine.delivery.q1">
																		<div class="form-control" readonly="readonly" :class="childLine.sync_quarter_q1 ? 'sync_quarter' : ''">{{childLine.delivery.q1.quantity}}</div>
																</div>
																</template>
																<template v-else>
																<o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.q1.quantity"
																										@previous-value="setPreviousQuantity($event, childLine, 'q1')"
																										@blur="setQuantityToParent(subLine, childLine, 'q1', index),
																										setBoxQuantity(line, 'q1', childLine.box_or_gadget, index)"
																										class="form-qty">
																</o-input-control>
																</template>
														</td>
														<td :class="{'d-none': sortalysContract, 'exist_error': (childLine && reqBiosApoItems.includes(address.id + '-' + childLine.product.id) && !isReadonly(childLine, 'q2', true))}">
																<template v-if="isReadonly(childLine, 'q2', true)">
																<div class="w-100 form-qty" v-if="childLine.delivery.q2">
																		<div class="form-control" readonly="readonly" :class="childLine.sync_quarter_q2 ? 'sync_quarter' : ''">{{childLine.delivery.q2.quantity}}</div>
																</div>
																</template>
																<template v-else>
																<o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.q2.quantity"
																										@previous-value="setPreviousQuantity($event, childLine, 'q2')"
																										@blur="setQuantityToParent(subLine, childLine, 'q2', index),
																										setBoxQuantity(line, 'q2', childLine.box_or_gadget, index)"
																										class="form-qty">
																</o-input-control>
																</template>
														</td>
														<td :class="{'d-none': sortalysContract, 'exist_error': (childLine && reqBiosApoItems.includes(address.id + '-' + childLine.product.id) && !isReadonly(childLine, 'q3', true))}">
																<template v-if="isReadonly(childLine, 'q3', true)">
																<div class="w-100 form-qty" v-if="childLine.delivery.q3">
																		<div class="form-control" readonly="readonly" :class="childLine.sync_quarter_q3 ? 'sync_quarter' : ''">{{childLine.delivery.q3.quantity}}</div>
																</div>
																</template>
																<template v-else>
																<o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.q3.quantity"
																										@previous-value="setPreviousQuantity($event, childLine, 'q3')"
																										@blur="setQuantityToParent(subLine, childLine, 'q3', index),
																										setBoxQuantity(line, 'q3', childLine.box_or_gadget, index)"
																										class="form-qty">
																</o-input-control>
																</template>
														</td>
														<td :class="{'d-none': sortalysContract, 'exist_error': (childLine && reqBiosApoItems.includes(address.id + '-' + childLine.product.id) && !isReadonly(childLine, 'q4', true))}">
																<template v-if="isReadonly(childLine, 'q4', true)">
																<div class="w-100 form-qty" v-if="childLine.delivery.q4">
																		<div class="form-control form-qty" readonly="readonly" :class="childLine.sync_quarter_q4 ? 'sync_quarter' : ''">{{childLine.delivery.q4.quantity}}</div>
																</div>
																</template>
																<template v-else>
																<o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.q4.quantity"
																										@previous-value="setPreviousQuantity($event, childLine, 'q4')"
																										@blur="setQuantityToParent(subLine, childLine, 'q4', index),
																										setBoxQuantity(line, 'q4', childLine.box_or_gadget, index)"
																										class="form-qty">
																</o-input-control>
																</template>
														</td>
														<td :class="{ 'exist_error': (childLine && fromDateErrorID.includes(address.id+'-'+childLine.product.id)), 'd-none': sortalysContract || (!!!childLine.delivery.yearly.quantity && !!!childLine.delivery.q1.quantity && !!!childLine.delivery.q2.quantity && !!!childLine.delivery.q3.quantity && !!!childLine.delivery.q4.quantity)}">
																<o-value-select-control v-model="childLine.valid_from_month" :items="months"
																												:readonly="!childLine.allow_manual_date_entry"
																												@change.native="setPrice(childLine, index), setDateChanged(childLine, 'from')">
																</o-value-select-control>
														</td>
														<td :class="{'d-none': sortalysContract || (!!!childLine.delivery.yearly.quantity && !!!childLine.delivery.q1.quantity && !!!childLine.delivery.q2.quantity && !!!childLine.delivery.q3.quantity && !!!childLine.delivery.q4.quantity)}">
																<o-value-select-control v-model="childLine.valid_to_month" :items="months"
																												:readonly="!childLine.allow_manual_date_entry"
																												@change.native="setPrice(childLine, index), setDateChanged(childLine, 'to')">
																</o-value-select-control>
														</td>
														</tr>
												</template>
												</template>
										</template>
										</template>
								</template>
								</tbody>
								<tbody v-else>
								<tr>
										<td align="center" colspan="11">{{ $t('core.no_records') }}</td>
								</tr>
								</tbody>
								</table>
						</div>
						<div v-else-if="(item.type == 'SD' || item.type == 'IMMUNO' || item.type == 'CNS' || item.type == 'ONCO' || item.type == 'SD_KUKO' || item.type == 'IMMUNO_KUKO' || item.type == 'CNS_KUKO' || item.type == 'ONCO_KUKO') && !address.fte">
								<div class="text-center">
								<p>{{$t('sandoz.set_fte_first')}}</p>
								</div>
						</div>
						<div v-else-if="(item.type == 'APO' || item.type == 'APO_KUKO' || item.type == 'BIOS_APO' || item.type == 'APO_OTC' || item.type == 'PV') && !address.customer_size">
								<div class="text-center py-4">
										<b-alert show variant="warning" class="d-inline-block px-4 py-3 font-weight-bold">
												<fa icon="exclamation-triangle" class="mr-2"/> {{ $t('sandoz.set_customer_size_first') }}
										</b-alert>
								</div>
						</div>
						</template>
				</template>
				

				<silent-box :gallery="pictures" :lazy-loading="true" class="silentbox-overlay-only" ref="imageSilentBox">
				</silent-box>

				<template #overlay>
					<div class="text-center">
						<p>{{$t('sandoz.set_type_first')}}</p>
					</div>
				</template>
			</b-overlay>
</template>

<script>
	import Vue from 'vue'
  export default {
    props: {
				item: {
        	type: Object,
        },
        sortalysContract: {
					type: Boolean,
        },
				user: {
					type: Object
				},
				determErrorID: {
					type: Array
				},
				fromDateErrorID: {
					type: Array
				},
				months: {
					type: Array
				},
				readonly: {
					type: Boolean
				},
        activeTab: {
          type: Number
        },
        pvContract: {
          type: Boolean,
          default: false
        },
        reqBiosApoItems: {
          type: Array
        },
		apoOtcContract: {
			type: Boolean,
			default: false
		},
		sortalysQuantity: {
			type: Number,
			default: 0
		},
		sortalysPrice: {
			type: Number,
			default: 0
		},
    },
    data: () => ({
			accordionItems: [],
			pictures: [],
			copyMasterProductToChild: []
    }),
    methods: {
			marketingActivityTotalAvailable() {
				this.item.marketing_activities_maximum = Number.isNaN(this.item.marketing_activities_maximum) || isNaN(parseFloat(this.item.marketing_activities_maximum)) ? 0 : parseFloat(this.item.marketing_activities_maximum)
				this.item.marketing_activities = Number.isNaN(this.item.marketing_activities) || isNaN(parseFloat(this.item.marketing_activities)) ? 0 : parseFloat(Math.round(this.item.marketing_activities))
				return this.item.marketing_activities_maximum - this.item.marketing_activities
			},
			checkLineChildren(line) {
				if(line.children && Object.keys(line.children).length)
				{
					return true
				}
				return false
			},
			toggleAccordion (address, item) {
				const index = this.getAccordion(address, item)
				if (index !== -1) {
					this.accordionItems.splice(index, 1);
				} else {
					this.accordionItems.push(address + '' + item)
				}
			},
			getAccordion(address, item) {
				return this.accordionItems.indexOf(address + '' + item)
			},
			linkValidate(link) {
				var linkUpdated = (link.indexOf('://') === -1) ? '//' + link : link;
				return linkUpdated
			},
			openPictureOverlay (line) {
      const self = this
				self.pictures = []
				self.pictures.push({
					src: '/storage/product/' + line.product.product_master.picture.path,
					alt: line.product.product_master.picture.name
				})
				console.log("self", self.$root)
				self.$refs.imageSilentBox.openOverlay(self.pictures[0], 0)
			},
			validatePrice(itm, index) {
				const self= this
				const basePrice = self.calculatePrice(itm, index)
				if(basePrice.price_changes && basePrice.price_changes.price_changes === 'no_changes_allowed') {
					this.$notify({
						title: this.$i18n.t('core.validation_error'),
						text: this.$i18n.t('sandoz.no_changes_allowed_error'),
						type: 'error'
					})
					itm.price = basePrice.price
					return false
				} else if(basePrice.price_changes && basePrice.price_changes.price_changes === 'minus_20_allowed') {
					const minPrice = parseFloat(((80 / 100) * basePrice.price).toFixed(0))
					if(itm.price < minPrice) {
						this.$notify({
							title: this.$i18n.t('core.validation_error'),
							text: this.$i18n.t('sandoz.minus_20_allowed_error'),
							type: 'error'
						})
						itm.price = minPrice
						return false
					}

					if(itm.price > basePrice.price) {
						this.$notify({
							title: this.$i18n.t('core.validation_error'),
							text: this.$i18n.t('sandoz.only_downward_error'),
							type: 'error'
						})
						itm.price = basePrice.price
						return false
					}
				} else if(basePrice.price_changes && basePrice.price_changes.price_changes === 'changes_allowed') {
					if(itm.price > basePrice.price) {
						this.$notify({
							title: this.$i18n.t('core.validation_error'),
							text: this.$i18n.t('sandoz.changes_allowed_error'),
							type: 'error'
						})
						itm.price = basePrice.price
						return false
					}
				} else if((basePrice.price_changes && basePrice.price_changes.price_changes === 'any_price_allowed') &&
					(itm.price === null || itm.price <= 0)
				) {
					self.$notify({
						title: this.$i18n.t('core.validation_error'),
						text: this.$i18n.t('sandoz.any_price_allowed_error'),
						type: 'error'
					})
					itm.price = basePrice.price
					return false
				}
			},
			isReadonly (line, q, child = false){
				let field = null
				let qStartMonth = null
				let qEndMonth = null
				let assinable = null
				switch (q) {
					case 'q1':
						field = 'user_date_q1_input'
						qStartMonth = 1
						qEndMonth = 3
						assinable= 'q1_assignable'
						break
					case 'q2':
						field = 'user_date_q2_input'
						qStartMonth = 4
						qEndMonth = 6
						assinable= 'q2_assignable'
						break
					case 'q3':
						field = 'user_date_q3_input'
						qStartMonth = 7
						qEndMonth = 9
						assinable= 'q3_assignable'
						break
					case 'q4':
						field = 'user_date_q4_input'
						qStartMonth = 10
						qEndMonth = 12
						assinable= 'q4_assignable'
						break
					case 'yearly':
						field = 'user_date_yearly_input'
						break
				}

				const isProductDisabled = line.product?.product_master?.disabled === true;

				if (q === 'yearly') {
					const hasField = Boolean(line[field]);

					const delivery = line.delivery?.[q];
					const isDeliveryValid = delivery && !delivery.is_deleted
						? !delivery.is_delivery_executed
						: true;

					const isEditable = hasField && isDeliveryValid;

					return !isEditable || isProductDisabled;
				}

				let validFromMonth = null
				if(line.valid_from_month) {
					validFromMonth = line.valid_from_month
				}
				let validToMonth = null
				if(line.valid_to_month) {
					validToMonth = line.valid_to_month
				}

				if(line.delivery && Object.keys(line.delivery).length && validFromMonth && validToMonth && line.delivery[q] && line.delivery[q].quantity > 0 && ((validFromMonth > qEndMonth || validToMonth < qStartMonth))) {
					line.delivery[q].quantity = null
				}

				const hasField = !!line[field];
				const validStart = !validFromMonth || validFromMonth <= qEndMonth;
				const validEnd = validToMonth && validToMonth >= qStartMonth;

				const hasDelivery = line.delivery && line.delivery[q];
				const deliveryValid = hasDelivery && !line.delivery[q].is_deleted
					? !line.delivery[q].is_delivery_executed
					: true;

				// Final logic
				const isEditable = hasField && validStart && validEnd && deliveryValid;

				// readonly if NOT editable OR product is disabled
				var readonlyVal = !isEditable || isProductDisabled;

				var sync = line.sync_quater_with_children
				// if(sync && !readonlyVal & q !== 'yearly' && child === true) {
				//   if(line[assinable] === 1){
				//     return false
				//   } else {
				//     line['sync_quarter_'+q] = true
				//     return true
				//   }
				// }
				return readonlyVal
			},
			setPreviousQuantity(value, itm, field = null) {
				if(itm.delivery[field]) {
					itm.delivery[field].previous_quantity = value
				}
			},
			setPrice(itm, index = -1, field = null) {
				const self = this
				const price = self.calculatePrice(itm, index, field)

				if(self.activeTab === 2 && price.maxQunatityError && field !== null) {
					self.$notify({
							title: this.$i18n.t('core.validation_error'),
							text: this.$i18n.t('sandoz.max_quantity_exceed'),
							type: 'error'
					})

					itm.delivery[field].quantity = itm.delivery[field].previous_quantity
					return false
				} else {
					itm.price = price.price
					itm.price_changes = price.price_changes
					self.$nextTick(function (){
						self.setSelectedItemPrice()
					});
				}

			},
			setQuantityToChild (itm, qtr, index = -1) {
				const self = this
				self.$nextTick(function (){
					if(itm.children && Object.keys(itm.children).length) {
						itm.children.forEach(function (subLine) {
							if (subLine.delivery && Object.keys(subLine.delivery).length) {
								if ((subLine.delivery[qtr] && subLine.child_qty)) {
									subLine.delivery[qtr].quantity = subLine.child_qty && itm.delivery[qtr].quantity !== null ? subLine.child_qty * itm.delivery[qtr].quantity : null
									self.$nextTick(function (){
										self.setPrice(subLine, index, qtr)
									})
								}
							}

							if(subLine.children && Object.keys(subLine.children).length) {
								subLine.children.forEach(function (childLine) {
									if (childLine.delivery && Object.keys(childLine.delivery).length) {
										if ((childLine.delivery[qtr] && childLine.child_qty)) {
											childLine.delivery[qtr].quantity = childLine.child_qty && itm.delivery[qtr].quantity !== null ? childLine.child_qty * childLine.delivery[qtr].quantity : null
											self.$nextTick(function () {
												self.setPrice(childLine, index, qtr)
											})
										}
									}
								})
							}
						})
					}
				})
			},
			setDateToChildren(line, i, type = 'from') {
				const self = this
				self.$nextTick(function (){
					if(!!line.allow_date_to_set_children) {
						if(line.children && Object.keys(line.children).length) {
							line.children.forEach(function (subLine) {
								if(type === 'from') {
									subLine.valid_from = line.valid_from
									subLine.valid_from_month = line.valid_from_month
									subLine.valid_from_year = line.valid_from_year
								} else {
									subLine.valid_to = line.valid_to
									subLine.valid_to_month = line.valid_to_month
									subLine.valid_to_year = line.valid_to_year
								}

								self.setPrice(subLine, i)

								if(!!subLine.allow_date_to_set_children) {
									if(subLine.children && Object.keys(subLine.children).length) {
										subLine.children.forEach(function (childLine) {
											if(type === 'from') {
												childLine.valid_from = subLine.valid_from
												childLine.valid_from_month = subLine.valid_from_month
												childLine.valid_from_year = subLine.valid_from_year
											} else {
												childLine.valid_to = subLine.valid_to
												childLine.valid_to_month = subLine.valid_to_month
												childLine.valid_to_year = subLine.valid_to_year
											}

											self.setPrice(childLine, i)
										})
									}
								}
							})
						}
					}
					self.setQuantityToChildSpecialLoad()
					self.setQuantityChildParent()
					self.setPrice(line, i)
				})
			},
			setDateChanged (line, type) {
				const self = this
				self.$nextTick(function () {
					if(!!line.allow_date_to_set_children) {
						self.setHighLighter(line)
						if(line.children && Object.keys(line.children).length) {
							line.children.forEach(function (subLine) {
									self.setHighLighter(subLine)
									if(type === 'from') {
										subLine.valid_from_changed = true
									} else {
										subLine.valid_to_changed = true
									}

									if(!!subLine.allow_date_to_set_children) {
										if(subLine.children && Object.keys(subLine.children).length) {
											subLine.children.forEach(function (childLine) {
												self.setHighLighter(childLine)
												if(type === 'from') {
													childLine.valid_from_changed = true
												} else {
													childLine.valid_to_changed = true
												}
											})
										}
									}
							})
						}
					}

					if (type === 'from') {
						line.valid_from_changed = true
					} else {
						line.valid_to_changed = true
					}
				})
			},
			setQuantityToParent(line, subLine, q, i) {
				const self = this
				var parentQuantityQuarter = 0
				let syncquatersWithChidren = []

				this.$nextTick(function (){
					self.setPrice(subLine, i, q)
					line['sync_quarter_'+q] = false
					if(line.children && Object.keys(line.children).length) {
						line.children.forEach(function (forSubLine, subLineIndex) {

							if(forSubLine.sync_quater_with_children) {
								var subLineQuantity = forSubLine.delivery && forSubLine.delivery[q] ? forSubLine.delivery[q].quantity: null
								forSubLine['sync_quarter_'+q] = false

								if(subLineQuantity !== null && syncquatersWithChidren.includes(q)) {
									forSubLine['sync_quarter_'+q] = true
									line['sync_quarter_'+q] = true
								}

								if(subLineQuantity !== null && !syncquatersWithChidren.includes(q)) {
									syncquatersWithChidren.push(q)
								}
							}

							if (!!forSubLine.write_qty_from_child_to_parent) {
								if(line.delivery) {
									var quantity = forSubLine.delivery ? parseInt(forSubLine.delivery[q].quantity) : 0
									if(quantity > 0) {
										parentQuantityQuarter += quantity
									}
								}
							}
						})
					}

					if(line.digitial_screen_category === true) {
						parentQuantityQuarter = parentQuantityQuarter === 0 ? null : parentQuantityQuarter
						line.delivery[q].quantity = parentQuantityQuarter

						// Set orange background to digitial_screen_category products
						let quaters = ['price', 'yearly', 'q1', 'q2', 'q3', 'q4'];
						var quaterQuantity = false
						quaters.forEach(function (q, qindex) {
							if(q !== 'price' && line.delivery[q] && line.delivery[q].quantity > 0) {
								quaterQuantity = true
							}
						})
						quaters.forEach(function (q1, qindex) {
							var quaterStartEndMonthData = self.getQuaterStartEndMonth(q1);
							if(q1 !== 'price' && (quaterStartEndMonthData.qStartMonth !== null && quaterStartEndMonthData.qEndMonth !== null && line.valid_from_month <= quaterStartEndMonthData.qEndMonth && line.valid_to_month >= quaterStartEndMonthData.qStartMonth) && quaterQuantity === true && line.delivery[q1] && (line.delivery[q1].quantity === null || line.delivery[q1].quantity === 0)) {
								line.delivery[q1].error = true
							} else {
								if(line.delivery[q1]) {
									line.delivery[q1].error = false
								}
							}
							self.setPrice(line, i , q1)
						})
					}
				})
			},
			setQuantityToChild (itm, qtr, index = -1) {
				const self = this
				self.$nextTick(function (){
					if(itm.children && Object.keys(itm.children).length) {
						itm.children.forEach(function (subLine) {
							if (subLine.delivery && Object.keys(subLine.delivery).length) {
								if ((subLine.delivery[qtr] && subLine.child_qty)) {
									subLine.delivery[qtr].quantity = subLine.child_qty && itm.delivery[qtr].quantity !== null ? subLine.child_qty * itm.delivery[qtr].quantity : null
									self.$nextTick(function (){
										self.setPrice(subLine, index, qtr)
									})
								}
							}

							if(subLine.children && Object.keys(subLine.children).length) {
								subLine.children.forEach(function (childLine) {
									if (childLine.delivery && Object.keys(childLine.delivery).length) {
										if ((childLine.delivery[qtr] && childLine.child_qty)) {
											childLine.delivery[qtr].quantity = childLine.child_qty && itm.delivery[qtr].quantity !== null ? childLine.child_qty * childLine.delivery[qtr].quantity : null
											self.$nextTick(function () {
												self.setPrice(childLine, index, qtr)
											})
										}
									}
								})
							}
						})
					}
				})
			},
			setBoxQuantity (item, qtr, boxOrGadget, index, lineIndex) {
				const self = this
				if(!['box', 'gadget'].includes(boxOrGadget)) {
					return
				}

				self.$nextTick(function (){
					let boxes = 0
					let gadgets = {yearly: 0, q1: 0, q2: 0, q3: 0, q4: 0}
					let itemBoxes = null
					let gadgetBoxes = null
					if(item.children && Object.keys(item.children).length) {
						item.children.forEach(function (subLine) {
							if (subLine.box_or_gadget === 'box' && subLine.delivery && Object.keys(subLine.delivery).length) {
								if ((subLine.delivery.yearly && subLine.delivery.yearly.quantity > 0)) {
									boxes = boxes + parseInt(subLine.delivery.yearly.quantity)
								}
							}

							if (subLine.box_or_gadget === 'gadget' && subLine.delivery && Object.keys(subLine.delivery).length) {
								Object.keys(subLine.delivery).forEach(function (p) {
									if ((subLine.delivery[p] && subLine.delivery[p].quantity > 0)) {
										gadgets[p] = gadgets[p] + parseInt(subLine.delivery[p].quantity)
									}
								})
							}

							if(subLine.children && Object.keys(subLine.children).length) {
								subLine.children.forEach(function (childLine) {
									if (childLine.box_or_gadget === 'gadget' && childLine.delivery && Object.keys(childLine.delivery).length) {
										Object.keys(childLine.delivery).forEach(function (p) {
											if ((childLine.delivery[p] && childLine.delivery[p].quantity > 0)) {
												gadgets[p] = gadgets[p] + parseInt(childLine.delivery[p].quantity)
											}
										})
									}

									if (childLine.box_or_gadget === 'box' && childLine.delivery && Object.keys(childLine.delivery).length) {
										if ((childLine.delivery.yearly && childLine.delivery.yearly.quantity > 0)) {
											boxes = boxes + parseInt(childLine.delivery.yearly.quantity)
										}
									}
								})
							}
						})
					}

					if(boxOrGadget === 'box') {
						Object.keys(item.delivery).forEach(function (p) {
							if ((item.delivery[p])) {
								gadgetBoxes = gadgets[p] ? gadgets[p] / 20 : null
								gadgetBoxes = gadgetBoxes ? gadgetBoxes.toString().split(".")[0]: null

								if(boxes < gadgetBoxes) {
									itemBoxes = boxes ? parseInt(boxes): null
								} else {
									itemBoxes = gadgetBoxes ? parseInt(gadgetBoxes): null
								}

								item.delivery[p].quantity = itemBoxes > 0 ? itemBoxes : null
								self.setPrice(item, index, qtr)
							}
						})
					} else if(boxOrGadget === 'gadget') {
						gadgetBoxes = gadgets[qtr] ? gadgets[qtr] / 20 : null
						gadgetBoxes = gadgetBoxes ? gadgetBoxes.toString().split(".")[0]: null

						if(boxes < gadgetBoxes) {
							itemBoxes = boxes ? parseInt(boxes): null
						} else {
							itemBoxes = gadgetBoxes ? parseInt(gadgetBoxes): null
						}

						if(item.delivery[qtr]) {
							item.delivery[qtr].quantity = itemBoxes > 0 ? itemBoxes : null
							self.setPrice(item, index, qtr)
						}
					}
					self.setHighLighter(item)
				})
			},
			setQuantityChildParent(fromland = 0) {
				if(this.item.addresses) {
					const self = this
					let quaters = ['price', 'yearly', 'q1', 'q2', 'q3', 'q4'];
					self.item.addresses.forEach(function (address, index) {
						if(address.address_type === 'delivery') {
							address.items.forEach(function (line, lineIndex) {
								let syncquatersWithChidren = []
								let quantities = {
									subItems: {
										q1_quantity: 0,
										q2_quantity: 0,
										q3_quantity: 0,
										q4_quantity: 0
									}
								}
								quaters.forEach(function (q, qindex) {
									// if(q === 'price' && line.price_changes && line.price_changes.price_changes !== 'no_changes_allowed') {
									//   self.validatePrice(line, index)
									// }

									if(fromland === 0 && !self.isReadonly(line, q) && q !== 'price') {
										self.setQuantityToChild(line, q, index)
									}

									line['sync_quarter_'+q] = false
								})

								if(line.children && Object.keys(line.children).length) {
									line.children.forEach(function (subLine, subLineIndex) {
										quaters.forEach(function (q, qindex) {

											if(subLine.sync_quater_with_children) {

												var subLineQuantity = subLine.delivery && subLine.delivery[q] ? subLine.delivery[q].quantity: null
												subLine['sync_quarter_'+q] = false

												if(subLineQuantity !== null && syncquatersWithChidren.includes(q)) {
													subLine['sync_quarter_'+q] = true
													line['sync_quarter_'+q] = true
												}

												if(subLineQuantity !== null && !syncquatersWithChidren.includes(q)) {
													syncquatersWithChidren.push(q)
												}
											}

											// if(q === 'price' && subLine.price_changes && subLine.price_changes.price_changes !== 'no_changes_allowed') {
											//   self.validatePrice(subLine, index)
											// }

											if(!self.isReadonly(subLine, q, true) && q !== 'price') {
												if (!!subLine.write_qty_from_child_to_parent) {
													if(line.delivery) {
														var subLineQuantity = subLine.delivery ? subLine.delivery[q].quantity: 0
														quantities.subItems[q+'_quantity'] += subLineQuantity
													}
												}

												self.setQuantityToParent(line, subLine, q, index)
												if(fromland === 0) {
													self.setQuantityToChild(subLine, q, subLineIndex)
													self.setBoxQuantity(line, q, subLine.box_or_gadget, index)
												}
											}

											if(q !== 'price' && subLine[q+'_quantity'] === true && !self.copyMasterProductToChild.includes(q)) {
												self.copyMasterProductToChild.push(q)
											}
										})

										// to sum of child quantity to parent
										self.$nextTick(function (){
											var quaterQuantity = false
											quaters.forEach(function (q, qindex) {
												if(quantities.subItems[q+'_quantity'] > 0) {
													if(line.digitial_screen_category === true) {
														quaterQuantity = true
													}
													line.delivery[q].quantity = quantities.subItems[q+'_quantity']
													self.setPrice(line, index , q)
												}
											})

											// Set orange background to digitial_screen_category products
											if(quaterQuantity){
												quaters.forEach(function (q, qindex) {
													var quaterStartEndMonthData = self.getQuaterStartEndMonth(q);
													if(q !== 'price' && (quaterStartEndMonthData.qStartMonth !== null && quaterStartEndMonthData.qEndMonth !== null && line.valid_from_month <= quaterStartEndMonthData.qEndMonth && line.valid_to_month >= quaterStartEndMonthData.qStartMonth) && line.delivery[q] && (line.delivery[q].quantity === null || line.delivery[q].quantity === 0)) {
														line.delivery[q].error = true
													} else {
														if(line.delivery[q]) {
															line.delivery[q].error = false
														}
													}
													self.setPrice(line, index , q)
												})
											}
										})

										if(subLine.children && Object.keys(subLine.children).length) {
											subLine.children.forEach(function (childLine, childLineIndex) {
												quaters.forEach(function (q, qindex) {
													// if(q === 'price' && childLine.price_changes && childLine.price_changes.price_changes !== 'no_changes_allowed') {
													//   self.validatePrice(childLine, index)
													// }

													if(!self.isReadonly(childLine, q, true) && q !== 'price') {
														self.setQuantityToParent(subLine, childLine, q, index),
														self.setBoxQuantity(line, q, childLine.box_or_gadget, index)
													}
												})
											})
										}
									})
								}
							})
						}
					})
				}
			},
			setQuantityToChildSpecial(itm, qtr, index) {
				const self = this
				self.$nextTick(function (){
					if(itm.digitial_screen_category === true) {
						if(itm.children && Object.keys(itm.children).length) {
							itm.children.forEach(function (subLine) {
								if(subLine.digitial_screen_category === true) {
									let quaters = ['q1', 'q2', 'q3', 'q4'];
									var totalQuantity = 0
									quaters.forEach(function (q, qindex) {
										if(itm.delivery[q] && itm.delivery[q].quantity > 0) {
											if(parseInt(itm.delivery[q].quantity) > totalQuantity) {
												totalQuantity = parseInt(itm.delivery[q].quantity)
											}
										}
									})

									if(totalQuantity > 0) {
										subLine.delivery['yearly'].quantity = totalQuantity
									} else {
										subLine.delivery['yearly'].quantity = null
									}
								}
							})
						}
					}
				})
			},
			calculatePrice(itm, index, field = null){
				const self = this
				let price = null
				let priceChanges = {}
				let capBasePrice = null
				let adjustablePrice = 'yes'
				let fixedIndependentFte = false
				const address = self.item.addresses[index === -1 ? self.addressIndex: index]
				if (itm.base_price && Object.keys(itm.base_price).length) {
					itm.base_price.forEach(function (p) {
						if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
							if (p.sales_line_price_category.category_type === 'classification') {
								if (p.sales_line_price_category.price_category === (address && address.customer_size)) {
									price = p.price ? p.price: null
									priceChanges = p.price_changes
									capBasePrice = p.sales_line_price_category
									adjustablePrice = p.adjustable_price
									fixedIndependentFte = p.fixed_independent_fte
									return false
								}
							} else if (p.sales_line_price_category.category_type === 'fte') {
								if (p.price && address.fte && p.sales_line_price_category.price_category === self.item.type) {
									if(p.fixed_independent_fte) {
										price = p.price
									} else {
										price = p.price * address.fte
									}

									capBasePrice = p.sales_line_price_category
									adjustablePrice = p.adjustable_price
									fixedIndependentFte = p.fixed_independent_fte
								}
								priceChanges = p.price_changes
								return false
							} else if (p.sales_line_price_category.category_type === 'fixed') {
								if (p.price) {
									price = p.price
									capBasePrice = p.sales_line_price_category
									adjustablePrice = p.adjustable_price
									fixedIndependentFte = p.fixed_independent_fte
								}
								priceChanges = p.price_changes
								return false
							}
						} else if(p.price_changes) {
							priceChanges = p.price_changes
							return false
						}
					})
				}

				if(capBasePrice !== null) {
					address.cap_base_price = capBasePrice
				}

				let quantity = null
				let yearlyQuantity = null
				let quaterlyAdjustablePrice = 0
				const results = self.getIncompleteQuartersWithMissingMonths(itm.valid_from_month, itm.valid_to_month)
				if (itm.delivery && Object.keys(itm.delivery).length) {
					Object.keys(itm.delivery).forEach(function (p) {
						if ((itm.delivery[p] && itm.delivery[p].quantity <= 0) && (!self.isGadgetOrBox(itm) || self.isReadonly(itm, p))) {
							return false
						}

						if(itm.delivery[p].quantity) {
							if(adjustablePrice === 'yes') {
								// First missing month of quarter check
								const missingQuarter = results.find(q => q.quarter === p)
								const qty = itm.delivery[p].quantity
								let effectivePrice = price

								if (missingQuarter) {
									const monthsInQuarter = 3 - missingQuarter.missingCount
									effectivePrice = (price / 3) * monthsInQuarter
								}
								quaterlyAdjustablePrice += effectivePrice * qty
							}

							quantity = quantity + parseInt(itm.delivery[p].quantity)
						}

						if(p === 'yearly') {
							yearlyQuantity = quantity
						}
					})
				}

				let maxQunatityError = false
				if((itm.max_quantity !== '' || itm.max_quantity !== null) && itm.max_quantity > 0) {
					if(parseInt(itm.max_quantity) < quantity) {
						maxQunatityError = true
					}
				}

				let newPrice = null
				if(priceChanges && priceChanges.price_changes && priceChanges.price_changes === 'any_price_allowed') {
					newPrice = itm.price * 1
				} else if(quantity && price) {
					if(adjustablePrice === 'yes') {
						
						let useYearlyCalc = (field === 'yearly');
						if (field === null && itm.delivery && itm.delivery.yearly && itm.delivery.yearly.quantity > 0) {
							useYearlyCalc = true;
						}

						if(!useYearlyCalc) {
							newPrice = parseFloat((quaterlyAdjustablePrice)).toFixed(2)
						} else {

							if(yearlyQuantity === null) {
								yearlyQuantity = quantity
							}

							let months = ((itm.valid_to_month - itm.valid_from_month) + 1) / 12
							let durationPrice = (price * months) * yearlyQuantity
							let qPrice = price * (quantity - yearlyQuantity)
							newPrice = parseFloat((durationPrice)).toFixed(2)
						}
						
						// self.$nextTick(function (){
						// 	let itemPrice = (price * months) * 1
						// 	itm.item_price = parseFloat((itemPrice)).toFixed(2)
						// });
						
					} else {
						newPrice = parseFloat(price * quantity).toFixed(2)
					}
				}
				else if(price) {
					if(adjustablePrice === 'yes') {
						let months = ((itm.valid_to_month - itm.valid_from_month) + 1) / 12
						let durationPrice = (price * months) * 1

						// self.$nextTick(function (){
						// 	itm.item_price = parseFloat((durationPrice)).toFixed(2)
						// });
					}
				}

				return {'price': newPrice ? newPrice : null, 'price_changes': priceChanges?priceChanges:{}, 'maxQunatityError': maxQunatityError}
			},
			setSelectedItemPrice() {
				const self = this
				let price = 0
				let countAddressCapExceed = 0
				self.item.addresses.forEach(function (address, key) {
					let addPrice = 0
					if (address.address_type === 'delivery') {
						address.items.forEach(function (item, key1) {
							let masterLinePrice = parseFloat(item.price) > 0 ? parseFloat(item.price) : 0
							addPrice = addPrice + parseFloat(masterLinePrice)
							price = parseFloat(price) + parseFloat(masterLinePrice)

							if(item.children && Object.keys(item.children).length) {
								let childrenPrice = self.getChildSelectedItemPrice(item)
								addPrice = addPrice + parseFloat(childrenPrice)
								price = price + parseFloat(childrenPrice)
							}
						})

						//addPrice = parseInt(self.item.marketing_activities_maximum)
						if(address.cap_base_price && (self.item.status === 'Draft' || self.item.status === 'Feedback')) {
							let exceedCap = parseInt(address.cap_base_price.cap)
							if(address.cap_base_price.category_type === 'classification' && address.cap_base_price.cap_method === 'fte' && address.fte) {
								addPrice = addPrice * address.fte
							}


							if(exceedCap !== null && addPrice !== 0 && exceedCap < addPrice) {
								address.cap_exceeded = true
								countAddressCapExceed = countAddressCapExceed + 1
							} else {
								address.cap_exceeded = false
							}
						}
					}
				})

				if(self.item.status === 'Draft' || self.item.status === 'Feedback'){
					self.item.cap_exceeded = false
				}

				if( countAddressCapExceed > 0) {
					self.item.cap_exceeded = true
				}

				if(self.item.status === 'Draft' || self.item.status === 'Feedback') {
					self.item.marketing_activities = Math.round(price)
				}

				if(self.sortalysContract) {
					self.item.marketing_activities_maximum = self.item.marketing_activities
				}
			},
			setHighLighter (item) {
				const self = this

				if(!['set'].includes(item.box_or_gadget)) {
					return
				}

				self.$nextTick(function (){
					let boxes = 0
					let gadgets = {yearly: 0, q1: 0, q2: 0, q3: 0, q4: 0}
					let quaterDisabled = {yearly: true, q1: true, q2: true, q3: true, q4: true}
					let gadgetBoxes = null
					if(item.children && Object.keys(item.children).length) {
						item.children.forEach(function (subLine) {
							if (subLine.box_or_gadget === 'box' && subLine.delivery && Object.keys(subLine.delivery).length) {
								if ((subLine.delivery.yearly && subLine.delivery.yearly.quantity > 0)) {
									boxes = boxes + parseInt(subLine.delivery.yearly.quantity)
								}
							}

							if (subLine.box_or_gadget === 'gadget' && subLine.delivery && Object.keys(subLine.delivery).length) {
								Object.keys(subLine.delivery).forEach(function (p) {
									if ((subLine.delivery[p] && subLine.delivery[p].quantity > 0)) {
										gadgets[p] = gadgets[p] + parseInt(subLine.delivery[p].quantity)
									}

									if(!self.isReadonly(subLine, p, true) && quaterDisabled[p] === true) {
										quaterDisabled[p] = false
									}
								})
							}

							if(subLine.children && Object.keys(subLine.children).length) {
								subLine.children.forEach(function (childLine) {
									if (childLine.box_or_gadget === 'gadget' && childLine.delivery && Object.keys(childLine.delivery).length) {
										Object.keys(childLine.delivery).forEach(function (p) {
											if ((childLine.delivery[p] && childLine.delivery[p].quantity > 0)) {
												gadgets[p] = gadgets[p] + parseInt(childLine.delivery[p].quantity)
											}

											if(!self.isReadonly(childLine, p, true) && quaterDisabled[p] === true) {
												quaterDisabled[p] = false
											}
										})
									}

									if (childLine.box_or_gadget === 'box' && childLine.delivery && Object.keys(childLine.delivery).length) {
										if ((childLine.delivery.yearly && childLine.delivery.yearly.quantity > 0)) {
											boxes = boxes + parseInt(childLine.delivery.yearly.quantity)
										}
									}
								})
							}
						})
					}

					Object.keys(item.delivery).forEach(function (p) {
						if ((item.delivery[p])) {
							item.delivery[p].error = false
							if(parseInt(boxes) > 0 && quaterDisabled[p] === false && ( gadgets[p] === 0 || ( (parseInt(boxes)*20) > gadgets[p]))) {
								item.delivery[p].error = true
							}
						}
					})
				})
			},
			getQuaterStartEndMonth(q) {
				var qStartMonth = null
				var qEndMonth = null
				switch (q) {
					case 'q1':
						qStartMonth = 1
						qEndMonth = 3
						break
					case 'q2':
						qStartMonth = 4
						qEndMonth = 6
						break
					case 'q3':
						qStartMonth = 7
						qEndMonth = 9
						break
					case 'q4':
						qStartMonth = 10
						qEndMonth = 12
						break
					case 'yearly':
						break
				}

				var quaterData =  {
					'qStartMonth': qStartMonth,
					'qEndMonth': qEndMonth
				}

				return quaterData
			},
			isGadgetOrBox (item){
				const self = this
				let is = false
				self.$nextTick(function (){
					if(item.children && Object.keys(item.children).length) {
						item.children.forEach(function (subLine) {
							if (subLine.box_or_gadget === 'box') {
								is = true
							}

							if(subLine.children && Object.keys(subLine.children).length) {
								subLine.children.forEach(function (childLine) {
									if (childLine.box_or_gadget === 'gadget') {
										is = true
									}
								})
							}
						})
					}
				})
				return is
			},
			getChildSelectedItemPrice(item) {
				let childPrice = 0
				const self = this
				item.children.forEach(function (item, key1) {
					let masterLineChildPrice = parseFloat(item.price) > 0 ? parseFloat(item.price) : 0
					childPrice = parseFloat(childPrice) + parseFloat(masterLineChildPrice)
					if(item.children && Object.keys(item.children).length) {
						let childrenPrice = self.getChildSelectedItemPrice(item)
						childPrice = parseFloat(childPrice) + parseFloat(childrenPrice)
					}
				})

				return childPrice
			},
			setQuantityToChildSpecialLoad() {
				if(this.item.addresses) {
					const self = this
					self.$nextTick(function (){
							self.item.addresses.forEach(function (address, index) {
							if(address.address_type === 'delivery') {
								address.items.forEach(function (line, lineIndex) {
									if(line.digitial_screen_category === true && line.children && Object.keys(line.children).length) {
										line.children.forEach(function (subLine, subLineIndex) {
											if(subLine.digitial_screen_category === true) {
												let quaters = ['q1', 'q2', 'q3', 'q4'];
												var totalQuantity = 0
												quaters.forEach(function (q, qindex) {
													if(line.delivery[q] && line.delivery[q].quantity > 0) {
														if(parseInt(line.delivery[q].quantity) > totalQuantity) {
															totalQuantity = parseInt(line.delivery[q].quantity)
														}
													}
												})

												if( totalQuantity > 0) {
													subLine.delivery['yearly'].quantity = totalQuantity
												} else {
													subLine.delivery['yearly'].quantity = null
												}
											}
										})
									}
								})
							}
						})
					})
				}
			},
			reactive(item) {
				return true
			},
			getIncompleteQuartersWithMissingMonths(validFromMonth, validToMonth) {
				validFromMonth = Number(validFromMonth)
				validToMonth = Number(validToMonth)

				const quarters = {
					q1: [1, 2, 3],
					q2: [4, 5, 6],
					q3: [7, 8, 9],
					q4: [10, 11, 12]
				}

				const coveredMonths = []
				for (let m = validFromMonth; m <= validToMonth; m++) {
					coveredMonths.push(m)
				}

				let result = []

				Object.keys(quarters).forEach(q => {
					const quarterMonths = quarters[q]

					const touched = quarterMonths.some(m => coveredMonths.indexOf(m) !== -1)
					if (!touched) return

					const missingMonths = quarterMonths.filter(
						m => coveredMonths.indexOf(m) === -1
					)

					if (missingMonths.length) {
						result.push({
							quarter: q,
							missingCount: missingMonths.length,
							missingMonths
						})
					}
				})

				return result
			}
    }
  }
</script>